import {
  Building, Setting2, UserTag
} from "iconsax-react";
import { getUser } from "../../services/local_service.js";

const user = getUser();
if (user) {
  var mobileNum = user.mobile;
}

const navigation = [
  {
    title: "Homepage",
    path: "/homepage",
    icon: Building,
    current: true,
  },
  {
    title: "Projects",
    path: "/projects",
    icon: Building,
    current: true,
  },
  // {
  //   title: "Project Release",
  //   path: "/projects-release",
  //   icon: Building,
  //   current: true,
  // },
  // {
  //   title: "Access Roles",
  //   path: "/configurations/access-roles",
  //   icon: Building,
  //   current: true,
  // },
  // {
  //   title: "Navigation Access",
  //   path: "/configurations/access-pages",
  //   icon: Building,
  //   current: true,
  // },
  // {
  //   title: "Certification",
  //   path: "/admin-certification",
  //   icon: Building,
  //   current: true,
  // },
  {
    title: "Portfolio",
    path: `/portfolio`,
    icon: Building,
    current: true,
  },
  {
    title: "Invoices",
    path: "/invoices",
    icon: Building,
    current: true,
  },

  {
    title: "Resources",
    path: "#0",
    icon: Building,
    subNav: [
      {
        title: "HMAC-SHA256 Simulator",
        path: "/resources/hmac-simulator",
      },
      {
        title: "Downloads",
        path: "/resources/downloads",
      },
    ]
  },
  {
    title: "Keys",
    path: "/developer/keys",
    icon: Building,
    current: true,
  },
  {
    title: "API Marketplace",
    path: "/developer/marketplace",
    icon: Building,
    current: true,
  },
  {
    title: "Billing",
    path: "/developer/billing",
    icon: Building,
    current: true,
  },
  {
    title: "Pricing Plans",
    path: "/pricing-plans",
    icon: Building,
    current: true,
  },
  {
    title: "Configuration",
    path: "#0",
    icon: Setting2,
    subNav: [
      {
        title: "Certificate Templates",
        path: "/configuration/certificate-templates",
      },
      {
        title: "Navigation Access",
        path: "/configuration/navigation-access",
      },
      {
        title: "Role Access",
        path: "/configuration/role-access",
      },
      {
        title: "Administrators",
        path: "/configuration/administrators",
      },
    ]
  },
  {
    title: "Administration",
    path: "#0",
    icon: UserTag,
    subNav: [
      {
        title: "Certification",
        path: "administration/certification",
      },
      {
        title: "Projects",
        path: "administration/projects",
      },
    ]
  },
  // {
  //   title: "Certification",
  //   path: "/certification",
  //   icon: Building,
  //   current: true,
  // },
  // {
  //   title: "Configurations",
  //   path: "/resource-groups/configurations/projects",
  //   icon: Setting2,
  //   subNav: [
  //     {
  //       title: "Projects",
  //       path: "/resource-groups/configurations/projects",
  //     },
  //     {
  //       title: "Project Billing Config",
  //       path: "/resource-groups/configurations/billings",
  //     },
  //     {
  //       title: "Subscription Plans",
  //       path: "/resource-groups/configurations/pricing-plans",
  //     },
  //     {
  //       title: "Certificate Templates",
  //       path: "/configurations/certificate-templates",
  //     },
  //   ]
  // }
];

export default navigation;
